import {
    LOGIN_REQUEST,
    LOGIN_FAILURE,
    LOGIN_SUCCESS,
    LOGOUT_FAILURE,
    LOGOUT_SUCCESS,
    VERIFY_JWT_REQUEST,
    VERIFY_JWT_FAILURE,
    VERIFY_JWT_SUCCESS,
    FORCE_NEW_SESSION,
} from './types';

const initialState = {
    initialized: false,
    authenticated: false,
    forcedSession: false,
    error: null,
    pending: false,
    experiments: {},
    isTpaasEnabled: false,
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case VERIFY_JWT_REQUEST:
            return {
                ...state,
                pending: true,
                error: null,
            };
        case VERIFY_JWT_FAILURE:
            return {
                ...state,
                error: payload,
                initialized: true,
                pending: false,
            };
        case VERIFY_JWT_SUCCESS:
            return {
                ...state,
                ...payload.data,
                initialized: true,
                pending: false,
            };
        case LOGIN_REQUEST:
            return {
                ...state,
                pending: true,
                error: null,
            };
        case LOGIN_FAILURE:
            return {
                ...state,
                error: payload,
                pending: false,
            };
        case LOGIN_SUCCESS:
            return {
                ...state,
                ...payload.data,
                initialized: true,
                pending: false,
            };
        case LOGOUT_FAILURE:
            return { ...state, error: payload };
        case LOGOUT_SUCCESS:
            return initialState;
        case FORCE_NEW_SESSION:
            return { ...state, forcedSession: true };
        default:
            return state;
    }
};
